var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path0, _path1, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoInternet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 310,
    viewBox: "0 0 408 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95429 8.95431 0 20 0H408V447H20C8.95432 447 0 438.046 0 427V20Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3464_281848",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 408,
    height: 447
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95429 8.95431 0 20 0H408V447H20C8.95432 447 0 438.046 0 427V20Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3464_281848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-172.5 506.333C-85.1112 506.333 -1.30159 476.44 60.4917 423.229C122.285 370.018 157 297.849 157 222.597C157 147.346 122.285 75.1763 60.4917 21.9655C-1.30152 -31.2454 -85.1111 -61.1389 -172.5 -61.1389L-172.5 222.597L-172.5 506.333Z",
    fill: "#FEE5DA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 327.5,
    cy: 310.569,
    rx: 31.5,
    ry: 27.125,
    transform: "rotate(-180 327.5 310.569)",
    fill: "#FEE5DA"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.145 168.024L318.516 164.356L322.991 197.008L311.588 206.105L281.392 204.135L280.145 168.024Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9275 112.511C72.7789 100.109 81.0908 88.3133 93.4926 86.1647L265.491 56.3661C277.893 54.2174 289.688 62.5293 291.837 74.9311L308.957 173.747C311.105 186.149 302.793 197.945 290.391 200.093L264.607 204.56L238.605 209.065L211.235 213.807L184.549 218.43L118.393 229.892C105.991 232.04 94.1959 223.728 92.0473 211.327L74.9275 112.511Z",
    fill: "url(#paint0_linear_3464_281848)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M271.334 218.099L308.738 212.988C318.287 211.683 324.971 202.884 323.666 193.335L308.914 85.3793C307.609 75.8302 298.81 69.1469 289.261 70.4518L197.163 83.0368L105.065 95.6218C95.5159 96.9267 88.8325 105.724 90.1374 115.273C90.357 116.881 90.5826 118.532 90.8097 120.194L99.731 196.351M271.334 218.099L216.64 225.573L161.946 233.047M271.334 218.099L161.946 233.047M161.946 233.047L122.528 238.433C112.734 239.772 103.784 232.715 102.801 222.878L101 204.851",
    stroke: "url(#paint1_linear_3464_281848)",
    strokeWidth: 2.53691,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9576 107.469C100.258 109.666 102.282 111.204 104.479 110.904C105.498 110.764 106.072 110.38 106.992 109.528C107.505 109.054 107.732 108.134 107.833 107.41C107.928 106.73 107.908 106.024 107.645 105.389C106.964 103.743 105.239 102.696 103.392 102.948C101.195 103.248 99.6574 105.273 99.9576 107.469Z",
    stroke: "url(#paint2_linear_3464_281848)",
    strokeWidth: 2.53691,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.167 105.841C113.467 108.038 115.491 109.575 117.688 109.275C118.707 109.136 119.584 108.626 120.201 107.9C120.416 107.647 120.593 107.19 120.732 106.701C121.093 105.432 121.166 103.994 120.387 102.929C119.545 101.778 118.114 101.113 116.601 101.32C114.404 101.62 112.866 103.644 113.167 105.841Z",
    stroke: "url(#paint3_linear_3464_281848)",
    strokeWidth: 2.53691,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.317 102.969C134.017 100.772 131.993 99.2343 129.796 99.5345C127.599 99.8346 126.062 101.859 126.362 104.056C126.662 106.253 128.686 107.79 130.883 107.49",
    stroke: "url(#paint4_linear_3464_281848)",
    strokeWidth: 2.53691,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.16,
    y: 124.708,
    width: 70.3053,
    height: 70.3053,
    rx: 35.1526,
    transform: "rotate(-7.78116 166.16 124.708)",
    fill: "#EB6973"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.606 167.139L207.627 167.136",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M200.904 162.189C203.638 158.488 208.854 157.703 212.556 160.436",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M192.992 156.348C192.501 157.015 192.644 157.954 193.311 158.446C193.978 158.937 194.917 158.794 195.408 158.127L192.992 156.348ZM202.046 153.028C202.817 152.725 203.197 151.854 202.894 151.083C202.591 150.312 201.721 149.932 200.949 150.235L202.046 153.028ZM210.351 149.178C209.532 149.052 208.766 149.613 208.64 150.431C208.513 151.25 209.074 152.016 209.893 152.143L210.351 149.178ZM216.616 154.964C217.28 155.46 218.22 155.323 218.716 154.659C219.211 153.996 219.075 153.056 218.411 152.56L216.616 154.964ZM195.408 158.127C197.096 155.835 199.397 154.068 202.046 153.028L200.949 150.235C197.774 151.482 195.015 153.601 192.992 156.348L195.408 158.127ZM209.893 152.143C212.331 152.52 214.639 153.488 216.616 154.964L218.411 152.56C216.041 150.791 213.274 149.63 210.351 149.178L209.893 152.143Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M186.289 151.398C185.797 152.065 185.939 153.004 186.606 153.496C187.273 153.987 188.212 153.845 188.704 153.178L186.289 151.398ZM194.852 147.391C195.547 146.941 195.746 146.012 195.296 145.317C194.845 144.621 193.917 144.423 193.221 144.873L194.852 147.391ZM199.692 141.844C198.901 142.091 198.461 142.933 198.708 143.723C198.956 144.514 199.797 144.955 200.588 144.707L199.692 141.844ZM221.565 148.233C222.232 148.725 223.171 148.584 223.663 147.918C224.155 147.252 224.014 146.312 223.348 145.82L221.565 148.233ZM188.704 153.178C190.387 150.894 192.47 148.933 194.852 147.391L193.221 144.873C190.535 146.612 188.187 148.822 186.289 151.398L188.704 153.178ZM200.588 144.707C207.742 142.469 215.536 143.779 221.565 148.233L223.348 145.82C216.548 140.798 207.76 139.32 199.692 141.844L200.588 144.707Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M184.416 139.026L227.077 170.53",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3464_281848",
    x1: 72.9379,
    y1: 77.35,
    x2: 240.159,
    y2: 232.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3464_281848",
    x1: 323.207,
    y1: 240.196,
    x2: 224.743,
    y2: 1.19847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FF8A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3464_281848",
    x1: 108.432,
    y1: 111.993,
    x2: 101.598,
    y2: 99.9553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FF8A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3464_281848",
    x1: 121.641,
    y1: 110.364,
    x2: 114.807,
    y2: 98.3268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FF8A8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3464_281848",
    x1: 134.836,
    y1: 108.579,
    x2: 128.002,
    y2: 96.5416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FF8A8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no-internet.6655f75a274d4592c17895b63fb85184.svg";
export { ForwardRef as ReactComponent };